'use strict';

/**
 * @ngdoc function
 * @name myConsultApp.controller:DashboardCtrl
 * @description
 * # PayPathCtrl
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'DashboardCtrl',
    function ($location, $scope, $rootScope, crumble, UserService, PatientsService) {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      $scope.crumble = crumble;
      crumble.update();
      if ($rootScope.currentOrganization) {
        $scope.getData = () => {
          PatientsService.getPatients(
            null,
            [1, 2].toString(),
            $rootScope.currentOrganization.id,
            null,
            '-owner__last_login',
          ).then(function (response) {
            $scope.petsresults = response.patients;
            $scope.setOrganizationProviders();
          });
        };
        $scope.setOrganizationProviders = function () {
          // Custom iteration for organization providers
          $scope.petsresults.forEach(function (element) {
            element.pet.organizationProviders = element.pet.association;
          });
        };

        $scope.goToOverview = function (patient) {
          $scope.setCurrentPet(patient.pet);
          $scope.setCurrentPetOwner(patient.pet_owner);
          $scope.getOwnerPets(patient.pet_owner.id);
          //$location.path('/pets/'+patient.pet.id+'/dashboard');
        };
        $scope.$on('$viewContentLoaded', async () => {
          $scope.getData();
        });
      }
    },
  );
